import { MessageProcessor } from '@/services/websocketProcessorTypes'
import store from '@/redux/store'
import {
  handleGroupMembersAdded,
  handleMessagesLoaded,
  handleNegotiationInvite,
  handleNegotiationMessagesLoaded,
  handleNegotiationResponse,
  handleNegotiationTerminated,
  handleUserNegotiations,
  setIsLoading,
  updateNegotiationMessage,
  incrementNegotiationUnread,
} from '@/redux/slices/negotiationWebsocketSlice'

export const negotiationProcessors: MessageProcessor[] = [
  {
    type: 'negotiation_invite',
    handler: (data) => {
      store.dispatch(handleNegotiationInvite(data))
    },
  },
  {
    type: 'negotiation_response',
    handler: (data) => {
      store.dispatch(handleNegotiationResponse(data))
    },
  },
  {
    type: 'negotiation_terminated',
    handler: (data) => {
      store.dispatch(handleNegotiationTerminated(data))
    },
  },
  {
    type: 'negotiation_message',
    handler: (data) => {
      const state = store.getState()
      const negotiationId = String(data.negotiation_id)
      const isNew = !state.negotiationWS.messages.some(
        (m) => m.id === data.id
      )
      const isFromSelf = data.sender === state.user.user?.email
      const isActive = String(state.chat.activeTab) === negotiationId
      if (isNew && !isFromSelf && !isActive) {
        store.dispatch(incrementNegotiationUnread(negotiationId))
      }

      store.dispatch(
        updateNegotiationMessage({
          type: 'negotiation',
          id: data.id,
          negotiationId: data.negotiation_id,
          user: data.sender,
          message: data.message,
          name: data.name,
          sender_role: data.sender_role,
          user_profile_picture: data.user_profile_picture,
          phase_id: data.phase_id,
          entrytime: data.entrytime,
          reply_to: data.reply_to,
        })
      )
    },
  },
  {
    type: 'group_members_added',
    handler: (data) => {
      store.dispatch(handleGroupMembersAdded(data))
    },
  },
  {
    type: 'user_negotiations',
    handler: (data) => {
      store.dispatch(
        handleUserNegotiations({
          negotiations: data.negotiations,
          messages: data.messages,
          pagination: data.pagination,
        })
      )
      store.dispatch(setIsLoading(false))
    },
  },
  {
    type: 'messages_loaded',
    handler: (data) => {
      store.dispatch(
        handleMessagesLoaded({
          messages: data.messages,
          pagination: data.pagination,
          negotiation_id: data.negotiation_id,
        })
      )
    },
  },
  {
    type: 'negotiation_messages_loaded',
    handler: (data) => {
      store.dispatch(
        handleNegotiationMessagesLoaded({
          messages: data.messages,
          pagination: data.pagination,
          negotiation_id: data.negotiation_id,
        })
      )
    },
  },
]
